import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  output,
  effect,
  computed,
  input,
  PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ProductIntegrationStatus } from '../../../enums';
import { ProductIntegrationNotificationDirective } from './directives/product-integration-notification.directive';
import { ProductIntegrationNotificationService } from '../../../services/product-integration-notification.service';

@Component({
  selector: 'aionz-product-integration-notification',
  standalone: true,
  imports: [MatIconModule, ProductIntegrationNotificationDirective],
  templateUrl: './product-integration-notification.component.html',
  styleUrl: './product-integration-notification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { popover: 'manual' }
})
export class ProductIntegrationNotificationComponent {
  private readonly _el = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly _notificationService = inject(ProductIntegrationNotificationService);
  private readonly _platformId = inject(PLATFORM_ID);

  public status = input<ProductIntegrationStatus | null>(null);
  public message = input<string | null>(null);
  public isVisible = input<boolean | null>(null);

  protected displayStatus = computed(
    () => this.status() ?? this._notificationService.state().status
  );
  protected displayMessage = computed(
    () => this.message() ?? this._notificationService.state().message
  );

  public onClose = output<void>();

  constructor() {
    effect(() => {
      if (!isPlatformBrowser(this._platformId)) {
        return;
      }

      const state = this._notificationService.state();
      const isVisibleFlag = this.isVisible() ?? state.isVisible;

      const el = this._el.nativeElement as HTMLElement & {
        showPopover: () => void;
        hidePopover: () => void;
      };

      if (isVisibleFlag) {
        if (!el.matches(':popover-open')) {
          el.showPopover();
        }
      } else if (el.matches(':popover-open')) {
        el.hidePopover();
      }
    });
  }

  public close(): void {
    this._notificationService.hide();
    this.onClose.emit();
  }
}
